export const FEATURES_CONSTANTS = {
  title: "Key Benefits of Encrypted Storage Clusters",
  list: [
    {
      label: "Data Encryption at Rest and in Transit",
      text: "Ensures that data is encrypted when stored and during transmission between nodes, protecting against interception and unauthorized access.",
    },
    {
      label: "Distributed Architecture",
      text: "Data is spread across multiple nodes, enhancing availability and resilience against hardware failures.",
    },
    {
      label: "Scalability",
      text: "Easily add or remove nodes to adjust storage capacity and performance according to organizational needs.",
    },
    {
      label: "Access Control",
      text: "Implements strict authentication and authorization mechanisms to ensure that only authorized personnel can access or modify data.",
    },
    {
      label: "Compliance Support",
      text: "Helps organizations meet regulatory requirements for data protection and privacy by providing robust encryption and security measures.",
    },
    {
      label: "Flexible Tenant Architecture",
      text: "Choose between fully isolated single-tenant clusters for high-security workloads or cost-optimized multi-tenant deployments—both with full compliance support.",
    },
  ],
};
